import { render } from "./MasterHeader.vue?vue&type=template&id=52123ca6&scoped=true"
import script from "./MasterHeader.vue?vue&type=script&lang=js"
export * from "./MasterHeader.vue?vue&type=script&lang=js"

import "../../public/css/style_master.css?vue&type=style&index=0&id=52123ca6&scoped=true&lang=css"

import exportComponent from "/var/www/html/giulietta/giulietta/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52123ca6"]])

export default __exports__